import { gql, useMutation, useQuery } from "@apollo/client";
import { Modal, RejectReplacementServiceOrderForm } from "components";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { wrapClick } from "utils";
import { GET_SERVICE_ORDER } from "./view";


const REJECT_SERVICE_ORDER = gql`
mutation ContractorRejectInstallationServiceOrder(
  $contractorRejectInstallationServiceOrderId: ID!
  $reason: String!
) {
  contractorRejectInstallationServiceOrder(
    id: $contractorRejectInstallationServiceOrderId
    reason: $reason
  ) {
    _id
  }
}
`

export default function RejectInstallationServiceOrderContainer({ open, setOpen, refetch }: { open: boolean; setOpen: (val: boolean) => void; refetch?: () => void }) {

  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id
    },
    notifyOnNetworkStatusChange: false
  });
  const [rejectInstallationServiceOrder] = useMutation(REJECT_SERVICE_ORDER)

  const form = useFormik({
    initialValues: {
      reason: "",
    },
    onSubmit: async (values) => {
      await rejectInstallationServiceOrder({
        variables: {
          contractorRejectInstallationServiceOrderId: searchParams.id,
          ...values
        }
      }).then(({ data }) => {
        if (data.contractorRejectInstallationServiceOrder._id) {
          toast(JSON.stringify({ type: "success", title: "Service Order Rejected Successfully" }))
          refetch?.();
          setOpen(false)
        }
        else {
          toast(JSON.stringify({ type: "error", title: "Could not reject Service Order" }))
        }
      })
    },
    onReset: () => {
      setOpen(false)
    }
  })

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Reject Service Order"
      size="4xl"
      description="Provide reasons for rejecting service order"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={form.isSubmitting}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Rejecting Service Order..." : "Reject Service Order"}
          </button>
        </>
      )}
    >
      {data?.installationServiceOrder?._id && (
        <RejectReplacementServiceOrderForm
          form={form}
        />
      )}
    </Modal>
  )
}
